<template>
<div class='widget-W0004V0001'>
  <div :class="placement" class="studentplan-widget">
    <div v-if="loading" class="widget-loader">
      <i class="fa fa-spinner"></i>
      Loading...
    </div>
    <div v-if="hasErrors">
      <ul class="errors">
        <li v-for="error in errors" v-bind:key="error" class="errors__error">{{ error }}</li>
      </ul>
    </div>
    <h2 class="weekplan-title"> UGEPLANER: </h2>
    <div class="widget-nav">
<span class="widget-nav__week-link"
      title="Se ugeplan for forrige uge"
      tabindex="0"
      v-on:click="getPreviousWeekPlan()"
      v-on:keypress="(e) => triggerGetPreviousWeekPlan(e)">&#x25C0</span>
      <span class="widget-nav__week-info">Uge {{ getFormatedActiveWeekNumber('WW') }}</span>
      <span class="widget-nav__week-link"
            title="Se ugeplan for næste uge"
            tabindex="0"
            v-on:click="getNextWeekPlan()"
            v-on:keypress="(e) => triggerGetNextWeekPlan(e)">&#x25B6</span>
    </div>
    <div v-for="(student, studentIndex) in data" v-if="!loading && !hasErrors" class="weekplan-container">
      <h3 class="studentname"> {{ student.name }} </h3>
      <div v-if="studentIndex < 1" class="weekdays">
        <div :id="studentIndex +''+ planIndex"
             class="weekdays__day"
             v-on:click="activeItemId = planIndex"
             v-for="(plan, planIndex) in student.weekPlan"
             v-bind:key="plan.date"
             :class="((activeItemId === planIndex)) ? 'active' :''">
          {{ getDayOfWeek(plan.date) }}
          <br>
          {{ getDateOfMonth(plan.date) }}
        </div>
        <span v-if="studentIndex < 1" v-for="(plan, planIndex) in student.weekPlan" class="circle"
              :class="(checkDayForTasks(planIndex))? 'visible' : ''">&#9679;</span>
      </div>
      <div class="weekplan">
        <div class="weekplan__column" v-for="(plan, planIndex) in student.weekPlan" v-bind:key="plan.date"
             :class="(activeItemId === planIndex) ? 'active' : ''">
          <div class="weekplan__column__head">
            <span class="plandate">{{ plan.date }} </span>
            <span class="childname">{{ student.name }} </span>
          </div>
          <div class="weekplan__column__tasks">
            <span v-if="!dayHasNoTasks(studentIndex, planIndex)"
                  class="no-tasks">Der er intet indhold for denne dag</span>
            <div
              v-for="task in plan.tasks"
              v-bind:key="task.id"
              :class="`weekplan-task weekplan-task--${task.type}`"
            >
              <div class="weekplan-task__top">
                <div class="pills-wrap">
                  <div v-for="pill in (task.pill ? task.pill.split(',') : [])" class="weekplan-task__pill">{{ pill }}
                  </div>
                </div>
                <div class="event-icon" :style="getBackgroundStyle(task.type)"></div>
              </div>
              <hr>
              <div class="weekplan-task__title">
                {{ task.title }}
              </div>
              <div class="weekplan-task__toggle-container" v-on:click="handleClick($event)" ref='containers'>
                <div class="weekplan-task__toggle-container__content js-content">
                  {{ task.content }}
                </div>
                <div class="weekplan-task__toggle-container__button js-button" data-more="Læs mere"
                     data-less="Læs mindre">
                  Læs mere
                </div>
              </div>
              <hr class="link-hr" v-if="task.linkText">
              <div class="weekplan-task--bottom" v-if="task.linkText">
                <div class="link-icon" :style="getLinkIcon()"></div>
                <form
                  :action="getApiBaseUrl() + 'relatedweekplanassignmentlinkauth'"
                  method="GET"
                  target="_blank"
                  class="weekplan-task__form">
                  <input type="hidden" name="id" :value="task.id"/>
                  <input type="hidden" name="childFilter[]" :value="student.unilogin"/>
                  <input type="hidden" name="sessionUUID" :value="sessionUUID"/>
                  <input type="hidden" name="aulaJWT" :value="aulaToken"/>
                  <input type="hidden" name="currentWeekNumber" :value="formatAulaYearWeek()"/>
                  <button
                    type="submit"
                    :title="`Se ${task.title} i Meebook`"
                    class="weekplan-task__link">
                    <span>{{ task.linkText }}</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>
<script>
var aulaWidgetMixin = {
  props: {
    axios: Function,
    moment: Function,
    getAulaToken: Function,
    devServer: String,
    sessionUUID: String,
    placement: String,
    currentWeekNumber: String,
    isMobileApp: Boolean,
    assuranceLevel: Number,
    userProfile: String,
    childFilter: [String, Array],
    institutionFilter: [String, Array],
    group: String,
    meebookImgBaseUrl: {
      type: String,
      default: 'https://app.meebook.com/images/aula/',
    },
    meebookApiBaseUrl: String,
  },
  data() {
    return {
      loading: true,
      items: [],
      errors: [],
      showAll: false,
      aulaToken: null,
    };
  },
  mounted() {
    this.aulaToken = this.getAulaToken();

// AULA JWTs live ~5 min. Keep ours fresh in the background so the
// hidden form inputs (which embed the token at render time) are
// always valid when the user clicks. Vue's reactivity updates the
// inputs automatically when this.aulaToken changes.
//
// NOTE: AULA support has explicitly disallowed addEventListener()
// on document or window in widgets, so we rely on setInterval alone.
    this._aulaTokenRefreshInterval = setInterval(() => {
      this.refreshAulaTokenSilently();
    }, 4 * 60 * 1000);
  },
  beforeDestroy() {
    if (this._aulaTokenRefreshInterval) {
      clearInterval(this._aulaTokenRefreshInterval);
    }
  },
  watch: {
    aulaToken: function (newVal, oldVal) {
// Only trigger loadContent on the initial token arrival (empty -> value).
// Subsequent token changes (from ensureAulaToken during 401 retry, paging,
// or time-based refresh) must NOT re-trigger loadContent — the widget's
// own isRetry logic handles reloads and caps them at 1 retry.
      if (newVal && !oldVal) {
        this.loadContent();
      }
    },
  },
  computed: {
    maxShown() {
      return this.showAll ? Infinity : 3;
    },
    hasErrors() {
      return this.errors && this.errors.length;
    },
  },
  methods: {
    async ensureAulaToken() {
      const fresh = await this.getAulaToken();
// Don't clobber a valid token with null/undefined — AULA can briefly
// return empty values while a new token is being negotiated.
      if (fresh) {
        this.aulaToken = fresh;
      }
      return this.aulaToken;
    },
    async refreshAulaTokenSilently() {
// Background refresh — never surface errors to the user. The 401
// retry path in loadContent() is still our backstop.
      try {
        const fresh = await this.getAulaToken();
        if (fresh) {
          this.aulaToken = fresh;
        }
      } catch (e) { /* swallow */
      }
    },
    async getClient() {
      await this.ensureAulaToken();
      return this.axios.create({
        baseURL: this.getApiBaseUrl(),
        timeout: 30000,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.aulaToken,
          'sessionUUID': this.sessionUUID,
          'X-Version': '1.0',
        },
      });
    },
    getApiBaseUrl() {
      return "https://app.meebook.com/aulaapi/";
    },
    getBookIcon() {
      return 'background-image: url(' + this.meebookImgBaseUrl + 'meebook-2x.png)';
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
  },
};
export default {
  mixins: [aulaWidgetMixin],
  props: {
    widgetIdentifier: {
      type: String,
      default: 'relatedWeekPlan-',
    },
  },
  methods: {
    addReadmore() {

      const containers = this.$refs.containers;
      if (containers) {
        containers.forEach((container) => {
          const content = container.querySelector('.js-content');
          const scrollHeight = content.scrollHeight;

// every row have aprox 17px line height
          if (scrollHeight > 51) {
            const button = container.querySelector('.js-button');
            button.classList.add('show');
          }
        });
      }
    },
    handleClick(event) {
      const element = event.currentTarget;
      const content = element.querySelector('.js-content');
      const button = element.querySelector('.js-button');
      const contentHeight = content.getBoundingClientRect().height;

// every row have aprox 17px line height
      if (content.classList.contains('open') && contentHeight > 51) {
        content.style.height = 51 + 'px';
        content.classList.remove('open');
        button.innerHTML = button.getAttribute('data-more');
      } else {
        content.style.height = contentHeight + 'px';
        content.style.height = content.scrollHeight + 'px';
        content.classList.add('open');
        button.innerHTML = button.getAttribute('data-less');
      }
    },
    getBackgroundStyle(type) {
      const typeMapping = {
        task: 'assignment',
        note: 'comment'
      };

      const mappedType = typeMapping[type] || type;
      return `background-image: url(${this.meebookImgBaseUrl}task-${mappedType}-2x.png);`;
    },
    getLinkIcon() {
      return `background-image: url(${this.meebookImgBaseUrl}link-2x.png)`;
    },
    getDate(date) {
      return this.moment(date);
    },
// Used to get the first letter in the name of the weekday.
    getDayOfWeek(date) {
      return date.substr(0, 2);
    },
// Extracting and returning number from day string.
    getDateOfMonth(date) {
      return date.match(/\d+/)[0];
    },
    formatAulaYearWeek() {
// format the aula year week string to folow moment year week format
      this.moment.locale('da');
      return this.moment(this.getCurrentWeekNumberPatchFormated()).format('GGGG-[W]WW');
    },
// get the active week number formated as just the week number
    getFormatedActiveWeekNumber(format) {
      return this.moment(this.getActiveWeekNumber()).format(format);
    },
// get the active week number formated as year-week
    getActiveWeekNumber() {
      return this.activeWeekNumber === null ? this.getCurrentWeekNumberPatchFormated() : this.activeWeekNumber;
    },
    getCurrentWeekNumberPatchFormated() {
// MEEB-2184
// The moment.js library can not format the currentWeekNumber string given by the AULA app when we
// are in the start of a year (weeks 1 - 9). The format is send as YYYY-[W]W... but should probably
// be sent as YYYY-[W]WW.. dvs. with leading zero for the week
// moment(2020-W7).format(moment.HTML5_FMT.WEEK) => FAILS
// moment(2020-W7).format('GGGG-[W]WW') => FAILS
//
// moment(2020-W07).format(moment.HTML5_FMT.WEEK) => SUCCESS
// moment(2020-W07).format('GGGG-[W]WW') => SUCCESS
//
// Sice Aula will not likely change this, we need to patch the format ourselvs per widget

// if the formated date string is longer than 7 chars, its the "correct" format
      if (this.currentWeekNumber.length > 7) {
        return this.currentWeekNumber;
      }

// if the length is below 7 add a leading "0" before the week number
      return this.currentWeekNumber.replace('W', 'W0');
    },
    dayHasNoTasks: function (studentIndex, planIndex) {
      return this.data[studentIndex].weekPlan[planIndex].tasks.length >= 1;
    },
//Return true if any child has tasks on a weekday.
    checkDayForTasks: function (planIndex) {
      let dayHasTask = false;
      this.data.forEach((student) => {
        if (student.weekPlan[planIndex].tasks.length >= 1) {
          dayHasTask = true;
        }
      });
      return dayHasTask;
    },
//fetch the week plan for the next week (activeWeekNumber + 1)
    async getNextWeekPlan() {
      let weekNumber = this.getActiveWeekNumber();
      this.moment.locale('da');
      this.activeWeekNumber = this.moment(weekNumber).add(1, 'w');
      await this.getWeekPlan(this.moment(this.activeWeekNumber).format('GGGG-[W]WW'));
    },
    async getWeekday() {
      let weekNumber = this.getActiveWeekNumber();
      this.moment.locale('da');
      this.activeWeekNumber = this.moment(weekNumber).add(1, 'w');
      await this.getWeekPlan(this.moment(this.activeWeekNumber).format('GGGG-[W]WW'));
    },
//trigger the get next week plan method by keboard pess of enter or space
    async triggerGetNextWeekPlan(e) {
      if (e.code === 'Enter' || e.code === 'Space') {
        await this.getNextWeekPlan();
      }
    },
//fetch the week plan for the next week (activeWeekNumber - 1)
    async getPreviousWeekPlan() {
      let weekNumber = this.getActiveWeekNumber();
      this.moment.locale('da');
      this.activeWeekNumber = this.moment(weekNumber).subtract(1, 'w');
      await this.getWeekPlan(this.moment(this.activeWeekNumber).format('GGGG-[W]WW'));
    },
//trigger the get previous week plan method by keboard pess of enter or space
    async triggerGetPreviousWeekPlan(e) {
      if (e.code === 'Enter' || e.code === 'Space') {
        await this.getPreviousWeekPlan();
      }
    },
// add wrapper method for fetching week plan data for the given year-week
    async getWeekPlan(yearWeek, isRetry = false) {
      this.errors = [];

      if (this.childFilter.length === 0) {
        this.errors.push('Vælg en eller flere elever i Aula top-menu for at se data');
        return;
      }

      try {
        let http = await this.getClient();

        const response = await http.get('relatedweekplan/all', {
          params: {
            currentWeekNumber: yearWeek,
            userProfile: this.userProfile,
            childFilter: this.childFilter,
            institutionFilter: this.institutionFilter,
          }
        });

        this.loading = false;
        this.data = response.data || [];

      } catch (error) {
        // 401 EXPIRED TOKEN LOGIC
        if (error.response && error.response.status === 401 && !isRetry) {
          this.loading = true;
          this.errors.push('Din Aula-token fornyes.. Øjeblik');

          try {
            // Fetch a fresh token from the parent AULA app
            await this.ensureAulaToken();

            // Remove the temporary visual error
            this.errors.pop();

            // Try the request one more time with the new token
            return this.getWeekPlan(yearWeek, true);
          } catch (retryError) {
            this.errors.pop();
          }
        }

        // STANDARD ERROR LOGIC
        this.loading = false;
        this.data = [];
        if (error.response && error.response.data && error.response.data.exceptionMessage) {
          this.errors.push(error.response.data.exceptionMessage);
        } else {
          this.errors.push('Ugeplanen kunne ikke hentes.');
        }
      }
    },
    async loadContent() {
      await this.getWeekPlan(this.formatAulaYearWeek());
    },
  },
  data: () => ({
    loading: true,
    activeWeekNumber: null,
    dayIsActive: false,
    activeItemId: 0,
    data: {},
    errors: [],
    aulaToken: null,
  }),
  mounted() {
    // Set today as active day.
    (this.moment().isoWeekday() <= 5) ? this.activeItemId = this.moment().isoWeekday() - 1 : this.activeItemId = 0;
  },
  updated() {
    this.addReadmore();
  },
  watch: {
    childFilter: async function () {
      if (this.aulaToken) {
        await this.loadContent();
      }
    }
  }
}
</script>

<style lang="scss">
.widget-W0004V0001 {
.widget-loader {
  font-family: "Lato", "Avenir", Helvetica, Arial, sans-serif;
  font-size: 16px;
  margin: 20px 0
}

.widget-loader > .fa {
  animation-name: spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-fill-mode: both;
  margin-right: 10px
}

@keyframes spin {
  0% {
    transform: rotate(0)
  }
  100% {
    transform: rotate(360deg)
  }
}

.errors {
  margin-top: 20px
}

.errors__error {
  display: block;
  padding: 15px 20px;
  background-color: #fff;
  color: #b50050
}

.no-tasks {
  display: block;
  text-align: center;
  padding: 10px
}

.widget-title {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #19405a;
  text-align: left;
  padding: 21px 10px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px
}

.widget-title h2 {
  margin: 10px 20px 10px 0;
  font-size: 32px;
  font-weight: 900;
  line-height: 34px;
  text-transform: uppercase
}

.widget-title h3 {
  margin: 0;
  vertical-align: bottom;
  font-size: 20px;
  font-weight: 400;
  line-height: 15px;
  margin-top: 15px;
  margin-bottom: 10px
}

.studentname {
  margin-bottom: 10px;
  font-size: 22px
}

.widget-nav {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  color: #19405a;
  text-align: left
}

.widget-nav span {
  margin: 7px 4px 7px 4px;
  vertical-align: bottom;
  font-size: 20px;
  font-weight: 400;
  line-height: 15px
}

.widget-nav__week-info {
  margin: 7px 10px 7px 10px;
  text-transform: uppercase
}

.widget-nav__week-link {
  font-size: 30px;
  font-weight: 700;
  cursor: pointer
}

.weekplan {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -8px
}

.weekplan__column {
  flex: 1 0 220px;
  width: 20%;
  max-width: 20%;
  border-left: 8px solid rgba(0, 0, 0, 0);
  margin-bottom: 20px
}

.weekplan__column span {
  font-size: 15px;
  font-weight: 500
}

.weekplan__column__head {
  background-color: #19405a;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  padding: 10px 10px
}

.weekplan__column__head:first-child {
  border-left: 0
}

.weekplan-task {
  background-color: #b4cdcf;
  padding: 8px 15px 8px 15px;
  text-align: left;
  font-size: 14px;
  margin-top: 10px;
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-size: 35px 35px
}

.weekplan-task__pill {
  display: inline-block;
  margin-right: 3px;
  text-align: center;
  background-color: #589ea5;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  border-radius: 10px;
  padding: 2px 12px;
  overflow: hidden
}

.weekplan-task--task {
  background-color: #f4e1e2;
  background-size: 18px;
  background-position: 96% 8%
}

.weekplan-task--task .weekplan-task__pill {
  background-color: #e46256
}

.weekplan-task--task .js-button {
  color: #e46256
}

.weekplan-task--task .js-button:hover {
  color: #efbbb8 !important
}

.weekplan-task--task hr {
  border-top-color: #efbbb8 !important
}

.weekplan-task--assignment {
  background-color: #f4e1e2;
  background-size: 18px;
  background-position: 96% 8%
}

.weekplan-task--assignment .weekplan-task__pill {
  background-color: #e46256
}

.weekplan-task--assignment .js-button {
  color: #e46256 !important
}

.weekplan-task--assignment hr {
  border-top-color: #efbbb8 !important
}

.weekplan-task--bottom {
  display: flex;
  align-items: center;
  gap: 5px;
  padding-top: 4px
}

.weekplan-task--bottom .link-icon {
  height: 18px;
  width: 18px;
  background-size: contain
}

.weekplan-task .link-hr {
  margin-top: 5px
}

.weekplan-task__toggle-container {
  position: relative;
  padding-top: 5px;
  cursor: pointer
}

.weekplan-task__toggle-container:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0
}

.weekplan-task__toggle-container__button {
  text-decoration: underline;
  display: none
}

.weekplan-task__toggle-container__button.show {
  display: block
}

.weekplan-task--assignment .weekplan-task__toggle-container:hover .weekplan-task__toggle-container__button {
  color: #e46256
}

.weekplan-task__toggle-container__content {
  display: block;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 0;
  width: 100%;
  line-height: 17px;
  padding: 0;
  transition: height .3s ease;
  cursor: pointer;
  word-break: break-word;
  white-space: pre-line
}

.weekplan-task__toggle-container__content.open {
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  text-overflow: unset
}

.weekplan-task__title {
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 0px
}

.weekplan-task__form {
  margin: 0;
  padding: 0
}

.weekplan-task__link {
  color: #2c3e50;
  cursor: pointer;
  text-decoration: underline;
  background-size: 18px;
  background-position: 1px 2px;
  background-repeat: no-repeat;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  text-align: left
}

.weekplan-task__link:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px
}

.weekplan-task__top {
  position: relative;
  min-height: 24px
}

.weekplan-task__top .pills-wrap {
  max-width: 94%
}

.weekplan-task__top .event-icon {
  background-size: 18px;
  height: 18px;
  width: 18px;
  position: absolute;
  top: 0;
  right: 0
}

.weekplan-task hr {
  height: 1px;
  width: calc(100% + 30px);
  border: 0;
  border-top: 1px solid #589ea5;
  margin: 1px -15px 1px -15px
}

.weekplan-task--comment {
  background-size: 18px;
  top: 5px
}

@media (max-width: 920px) {
  .studentplan-widget {
    margin: auto;
    max-width: 440px
  }

  .weekplan-container:last-of-type {
    margin-bottom: 20px
  }

  .plandate, .studentname {
    display: none
  }

  .childname {
    display: block
  }

  .weekplan-title {
    width: 50%;
    margin-top: 5px;
    display: inline-block;
    font-weight: 500;
    font-size: 20px
  }

  .widget-nav {
    width: 50%;
    font-weight: 500;
    float: right;
    display: inline-block;
    margin-top: 4px;
    text-align: right
  }

  .widget-title h2 {
    margin: 10px 20px 10px 0
  }

  .widget-title h2, .widget-nav span {
    font-size: 18px
  }

  .widget-title h3 {
    display: block;
    width: 100%
  }

  .widget-nav__week-link, .widget-nav span {
    margin-top: 10px
  }

  .weekdays {
    padding-bottom: 10px;
    width: 100%;
    display: inline-block
  }

  .weekdays__day {
    border-right: 1px solid #bebebe;
    height: auto;
    width: 20%;
    text-align: center;
    padding: 10px;
    background-color: #eeeff1;
    color: #19405a;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block
  }

  .weekdays__day:last-of-type {
    border-right: none
  }

  .weekdays__day.active {
    background-color: #19405a;
    color: #fff
  }

  .weekdays .circle {
    display: inline-block;
    width: 20%;
    height: auto;
    text-align: center;
    visibility: hidden
  }

  .weekdays .circle.visible {
    visibility: visible
  }

  .weekplan-container:not(:first-child) .weekplan__column__head {
    margin-top: 10px !important
  }

  .weekplan__column {
    display: none;
    width: 100%;
    max-width: none;
    margin: auto
  }

  .weekplan__column.active {
    display: block;
    width: 100%;
    max-width: none
  }

  .weekplan-container {
    max-width: 440px;
    margin: auto
  }

  .weekplan__column__tasks span {
    display: block;
    font-size: 16px;
    font-weight: 500
  }
}

@media (min-width: 920px) {
  .weekdays, .childname {
    display: none
  }
}

.narrow .studentplan-widget {
  margin: auto;
  max-width: 440px
}

.narrow .weekplan-container:last-of-type {
  margin-bottom: 20px
}

.narrow .plandate, .narrow .studentname {
  display: none
}

.narrow .childname {
  display: block
}

.narrow .weekplan-title {
  width: 50%;
  margin-top: 5px;
  display: inline-block;
  font-weight: 500;
  font-size: 20px
}

.narrow .widget-nav {
  width: 50%;
  font-weight: 500;
  float: right;
  display: inline-block;
  margin-top: 4px;
  text-align: right
}

.narrow .widget-title h2 {
  margin: 10px 20px 10px 0
}

.narrow .widget-title h2, .narrow .widget-nav span {
  font-size: 18px
}

.narrow .widget-title h3 {
  display: block;
  width: 100%
}

.narrow .widget-nav__week-link, .narrow .widget-nav span {
  margin-top: 10px
}

.narrow .weekdays {
  padding-bottom: 10px;
  width: 100%;
  display: inline-block
}

.narrow .weekdays__day {
  border-right: 1px solid #bebebe;
  height: auto;
  width: 20%;
  text-align: center;
  padding: 10px;
  background-color: #eeeff1;
  color: #19405a;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  display: inline-block
}

.narrow .weekdays__day:last-of-type {
  border-right: none
}

.narrow .weekdays__day.active {
  background-color: #19405a;
  color: #fff
}

.narrow .weekdays .circle {
  display: inline-block;
  width: 20%;
  height: auto;
  text-align: center;
  visibility: hidden
}

.narrow .weekdays .circle.visible {
  visibility: visible
}

.narrow .weekplan-container:not(:first-child) .weekplan__column__head {
  margin-top: 10px !important
}

.narrow .weekplan__column {
  display: none;
  width: 100%;
  max-width: none;
  margin: auto
}

.narrow .weekplan__column.active {
  display: block;
  width: 100%;
  max-width: none
}

.narrow .weekplan-container {
  max-width: 440px;
  margin: auto
}

.narrow .weekplan__column__tasks span {
  display: block;
  font-size: 16px;
  font-weight: 500
}

@media only screen and (max-width: 1300px)and (min-width: 980px) {
  .medium .studentplan-widget {
    margin: auto;
    max-width: 440px
  }

  .medium .weekplan-container:last-of-type {
    margin-bottom: 20px
  }

  .medium .plandate, .medium .studentname {
    display: none
  }

  .medium .childname {
    display: block
  }

  .medium .weekplan-title {
    width: 50%;
    margin-top: 5px;
    display: inline-block;
    font-weight: 500;
    font-size: 20px
  }

  .medium .widget-nav {
    width: 50%;
    font-weight: 500;
    float: right;
    display: inline-block;
    margin-top: 4px;
    text-align: right
  }

  .medium .widget-title h2 {
    margin: 10px 20px 10px 0
  }

  .medium .widget-title h2, .medium .widget-nav span {
    font-size: 18px
  }

  .medium .widget-title h3 {
    display: block;
    width: 100%
  }

  .medium .widget-nav__week-link, .medium .widget-nav span {
    margin-top: 10px
  }

  .medium .weekdays {
    padding-bottom: 10px;
    width: 100%;
    display: inline-block
  }

  .medium .weekdays__day {
    border-right: 1px solid #bebebe;
    height: auto;
    width: 20%;
    text-align: center;
    padding: 10px;
    background-color: #eeeff1;
    color: #19405a;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block
  }

  .medium .weekdays__day:last-of-type {
    border-right: none
  }

  .medium .weekdays__day.active {
    background-color: #19405a;
    color: #fff
  }

  .medium .weekdays .circle {
    display: inline-block;
    width: 20%;
    height: auto;
    text-align: center;
    visibility: hidden
  }

  .medium .weekdays .circle.visible {
    visibility: visible
  }

  .medium .weekplan-container:not(:first-child) .weekplan__column__head {
    margin-top: 10px !important
  }

  .medium .weekplan__column {
    display: none;
    width: 100%;
    max-width: none;
    margin: auto
  }

  .medium .weekplan__column.active {
    display: block;
    width: 100%;
    max-width: none
  }

  .medium .weekplan-container {
    max-width: 440px;
    margin: auto
  }

  .medium .weekplan__column__tasks span {
    display: block;
    font-size: 16px;
    font-weight: 500
  }
}
}
</style>
